import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Grid2, IconButton, Stack, Tooltip, Typography, useTheme, } from "@mui/material";
import TableComponent from "components/grid";
import { useNavigate, useParams } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useGetSubmittedDocumentsQuery } from "store/slices/apis/documentsSlice";
import moment from "moment";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { API_END_POINT } from "config";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { MdArrowBackIosNew } from "react-icons/md";
import { FaCheckSquare } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { TbDots } from "react-icons/tb";
import EditDocument from "./EditDocument";
import ActivityListItem from "./ActivityListItem";
import { FILE_ICONS } from "config";
import { ENGINEERING_DCOCUMENT_VIEW } from "config";
import { usePermission } from "hooks/usePermission";
import { ENGINEERING_DCOCUMENT_EDIT } from "config";
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

// const columns = [
//     {
//         name: "Document ID",
//         field: "issueNumber",
//         renderer(params) {
//             return (
//                 <Stack direction="row" spacing={1}>
//                     {params?.documentId &&
//                         <Chip label={params?.documentId} size="small" sx={{
//                             fontSize: '12px',
//                             '& .MuiChip-label': {
//                                 paddingLeft: '8px',
//                                 paddingRight: '8px',
//                                 fontWeight: 600
//                             }
//                         }} />
//                     }
//                 </Stack>
//             );
//         }
//     },
//     {
//         name: "Document Name",
//         field: "documentName",
//     },
//     {
//         name: "Plan Date",
//         field: "planDate",
//         renderer(params) {
//             return (
//                 <>
//                     {params?.planDate
//                         ? moment(params.planDate).format("DD/MM/YY")
//                         : ""}
//                 </>
//             );
//         },
//     },
//     {
//         name: "Activity Name",
//         field: "activityName",
//     },
//     {
//         name: "Activity Start Date",
//         field: "activitySatartDate",
//         renderer(params) {
//             return (
//                 <>
//                     {params?.activitySatartDate
//                         ? moment(params.activitySatartDate).format("DD/MM/YY")
//                         : ""}
//                 </>
//             );
//         },
//     },
//     {
//         name: "Activity End Date",
//         field: "activityEndDate",
//         renderer(params) {
//             return (
//                 <>
//                     {params?.activityEndDate
//                         ? moment(params.activityEndDate).format("DD/MM/YY")
//                         : ""}
//                 </>
//             );
//         },
//     },
//     {
//         name: "Created Date",
//         field: "createdDate",
//         renderer(params) {
//             return (
//                 <>
//                     {params?.createdDate
//                         ? moment(params.createdDate).format("DD/MM/YY")
//                         : ""}
//                 </>
//             );
//         },
//     },
//     {
//         name: "Workflow Date",
//         field: "approvedDate",
//         renderer(params) {
//             return (
//                 <>
//                     {params?.approvedDate
//                         ? moment(params.approvedDate).format("DD/MM/YY")
//                         : ""}
//                 </>
//             );
//         },
//     },
//     {
//         name: "Status",
//         field: "status"
//     },
//     {
//         name: "Comment",
//         field: "comment",
//         renderer(params) {
//             return (
//                 <>
//                     {params?.status != 'Pending' ?
//                         params?.comment ?
//                             <Tooltip
//                                 placement="top"
//                                 title={params?.comment}
//                                 arrow
//                                 slotProps={{
//                                     tooltip: { sx: { fontSize: "12px" } },
//                                 }}
//                             >
//                                 <IconButton
//                                     aria-label="download"
//                                     size="small"
//                                     sx={{
//                                         color: '#00d26a'
//                                     }}
//                                 >
//                                     <FaCheckSquare />
//                                 </IconButton>
//                             </Tooltip>

//                             : <>
//                                 <IconButton
//                                     aria-label="download"
//                                     size="small"
//                                     sx={{
//                                         color: '#e2483d'
//                                     }}
//                                 >
//                                     <MdCancel />
//                                 </IconButton>
//                             </>

//                         : <>
//                             <IconButton
//                                 aria-label="download"
//                                 size="small"
//                             >
//                                 <TbDots />
//                             </IconButton>
//                         </>
//                     }

//                 </>
//             );
//         },
//     },
//     {
//         name: 'Action',
//         field: 'action',
//         option: {
//             view: true,
//             download: true,
//             editOfDocument: true,
//         }
//     },
// ];

const columns = [
    {
        name: "File Name",
        field: "fileName",
        renderer(params) {
            const extension = params?.docFileName.split('.').pop();
            const icon = FILE_ICONS?.find((i) => i?.type == extension)

            return (
                <Stack direction="row" alignItems="center" spacing={0} mt={0.5}>
                    {icon?.icon}
                    <Typography variant="caption"
                        sx={{
                            fontSize: '14px',
                            fontWeight: 500,
                            lineHeight: "100%",
                            letterSpacing: '-0.4px',
                            marginLeft: '10px'
                        }}
                    >
                        {params?.documentName}
                    </Typography>
                </Stack>
            );
        }
    },
    {
        name: "Work Flow Status",
        field: "status",
    },
    {
        name: "Last Updated At",
        field: "createdDate",
        renderer(params) {
            return (
                <>
                    {params?.createdDate
                        ? moment(params.createdDate).format("DD/MM/YYYY")
                        : ""}
                </>
            );
        },
    },
    {
        name: "Action",
        field: "action",
        option: {}
    },
];

const SubmittedByMeDocuments = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const documentViewAccess = usePermission(ENGINEERING_DCOCUMENT_VIEW);
    const documentEditAccess = usePermission(ENGINEERING_DCOCUMENT_EDIT);
    const dispatch = useDispatch();
    const { projectId } = useParams();
    const { activityId } = useParams();

    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: ""
    });

    const [isEditDocument, setIsEditDocument] = useState(false);
    const [rowData, setRowData] = useState(null);

    const [submittedListData, setSubmittedListData] = useState([]);

    const { data: submittedList, isLoading, isSuccess: submittedIsSuccess, isError: submittedIsError } = useGetSubmittedDocumentsQuery({
        projectId: projectId,
        activityId: activityId,
        fromDate: filters?.fromDate,
        toDate: filters?.toDate,
        page: pageNumber,
        pageSize: pageSize,
    });

    useEffect(() => {
        if (submittedIsSuccess) {
            setSubmittedListData(submittedList?.data?.data)
        }
    }, [submittedList, submittedIsSuccess, submittedIsError])

    // const handleActionView = (row) => {
    //     window.open(`${API_END_POINT}issues/view/${row?.docFileName}`, '_blank');
    // }

    const handleActionDownload = async (row) => {

        // try {
        //     const response = await fetch(`${API_END_POINT}issues/view/${row?.docFileName}`, {
        //         method: 'GET',
        //         headers: {
        //             // If you need auth headers, add here
        //             // 'Authorization': 'Bearer YOUR_TOKEN',
        //         },
        //     });

        //     if (!response.ok) throw new Error('Failed to download file');

        //     const blob = await response.blob();
        //     const blobUrl = window.URL.createObjectURL(blob);

        //     const link = document.createElement('a');
        //     link.href = blobUrl;
        //     link.download = row?.documentName;
        //     document.body.appendChild(link);
        //     link.click();

        //     // Cleanup
        //     link.remove();
        //     window.URL.revokeObjectURL(blobUrl);
        // } catch (err) {
        //     console.error('Error downloading file:', err);
        //     openNotification('Download failed. Please check the file URL or network.');
        // }
    }

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    const handleRedirect = (row) => {
        // navigate(`/projects/${projectId}//${activityId}/${row?.id}`)
        navigate(`/projects/${projectId}/documents/documents-submitted-by-me/${row?.id}`)
    }
    const CustomCalendarIcon = (props) => (
        <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
    );

    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    const handleActionView = (row) => {
        const encrypted = encrypt("view");
        navigate(`/projects/${projectId}/document-detail/${row?.id}/${encrypted}/false`)
    }

    const handleEditDocument = (row) => {
        setIsEditDocument((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: "20px" }}>
                <Grid2 size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: { xs: 'start', sm: 'center' },
                            justifyContent: "space-between",
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            sx={{
                                // flexGrow: 2,
                                alignItems: { xs: "stretch", sm: "center" },
                                width: { xs: '100%', sm: 'auto' },
                                "& .MuiStack-root": {
                                    paddingTop: "15px",
                                },
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setFromDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 150,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: "",
                                                        toDate: toDate
                                                            ? dayjs(toDate).format("YYYY-MM-DD")
                                                            : "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        format="DD-MM-YYYY"
                                        clearable={true}
                                        onChange={(newValue) => setToDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 150,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: fromDate
                                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                                            : "",
                                                        toDate: "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <Button
                                // loading={isLoading}
                                onClick={() => {
                                    setFilters({
                                        fromDate: fromDate
                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                            : "",
                                        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : ""
                                    });
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Search
                            </Button>
                            <Button
                                // loading={isLoading}
                                onClick={() => {
                                    setFromDate(null)
                                    setToDate(null)
                                    const clearedValues = Object.fromEntries(
                                        Object.keys(filters).map(key => [key, ""])
                                    );
                                    setFilters(clearedValues);
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Reset
                            </Button>
                        </Stack>
                        {/* <Button
                            variant="contained"
                            startIcon={<MdArrowBackIosNew sx={{ marginBottom: "2px" }} />}
                            onClick={() => {
                                navigate(`/projects/${projectId}/engineering/all-activities`)
                            }}
                            // loading={updateManpowerRes?.isLoading}
                            sx={{
                                backgroundColor: `${theme?.customSettings?.themeColor}`,
                                color: "#FFF",
                                padding: "5px 20px",
                                fontWeight: "500",
                                textTransform: "none",
                                fontSize: "16px",
                                marginTop: "11px",
                                marginLeft: 1,
                                border: `1px solid ${theme?.customSettings?.themeColor}`,
                                '&.Mui-disabled': {
                                    border: 'none'
                                }
                            }}
                        >
                            Activity List
                        </Button> */}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3 }} sx={{ mt: 2, maxHeight: { xs: '200px', sm: 'none', md: 'none', lg: 'none' }, overflowY: 'auto' }}>
                    <ActivityListItem handleRedirect={handleRedirect} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9 }} sx={{ mt: 2 }}>
                    <TableComponent
                        columns={columns
                            .map((col) =>
                                col.field === "action"
                                    ? {
                                        ...col,
                                        option: {
                                            ...col.option,
                                            view: documentViewAccess,
                                            // edit:documentEditAccess
                                        },
                                    }
                                    : col
                            )
                            .filter((col) => {
                                if (col.field !== "action") {
                                    return true;
                                } else {
                                    return Object.values(col.option).some((v) => v === true);
                                }

                            })}
                        data={submittedListData}
                        type="border"
                        actionView={handleActionView}
                        actionDownload={handleActionDownload}
                        actionEdit={handleEditDocument}
                    />
                    <Box sx={{ display: "flex", justifyContent: "end" }}>
                        <PaginationComponent
                            pageNumber={submittedList?.data?.pagination?.currentPage || 1}
                            totalPages={submittedList?.data?.pagination?.totalPages || 1}
                            onPageChange={setPageNumber}
                        />
                    </Box>
                </Grid2>
            </Grid2>
            {isEditDocument &&
                <EditDocument open={isEditDocument} cancelIssue={handleEditDocument} rowData={rowData} openNotification={openNotification} />
            }

        </>
    );
}

export default SubmittedByMeDocuments;
